import { get, post, put, del } from './requests.js'

const COHORTS = 'cohort-feeds'
const DATA_EXPLORER = 'data-explorer'
const EVENTS = 'event-feeds'
const UNIFIED_USER_PROFILE = 'unified-user-profile'
const PREBUILT_ATTRIBUTES_V2 = 'prebuilt-attributes-v2'

export const getCohortsSchema = () => get([COHORTS, 'schema'])

export const getCohortsStatistics = () => get([DATA_EXPLORER, 'statistics'])

export const getEventsStatistics = (payload) =>
  post([DATA_EXPLORER, 'statistics'], { transformPayload: false }, payload)

// Todo: Remove when mock data not needed
export const getMockEventsStatistics = () => get([DATA_EXPLORER, 'statistics-2'])

export const getEventsSchema = () => get([EVENTS, 'schema'], { transformPayload: false })

export const getEventFeeds = () => get(EVENTS)

export const getEventFeed = (id) => get([EVENTS, id])

export const updateEventFeed = (id, payload) => put([EVENTS, id], {}, payload)

export const deleteEventFeed = (id) => del([EVENTS, id])

export const createEventFeed = (payload) => del([EVENTS], {}, payload)

export const getUnifiedUserProfileSchema = () =>
  get([UNIFIED_USER_PROFILE, 'schema'], { transformPayload: false })

export const getUnifiedUserProfileList = () => get(UNIFIED_USER_PROFILE)

export const getUnifiedUserProfile = (id) => get([UNIFIED_USER_PROFILE, id])

export const updateUnifiedUserProfile = (id, payload) =>
  put([UNIFIED_USER_PROFILE, id], {}, payload)

export const deleteUnifiedUserProfile = (id) => del([UNIFIED_USER_PROFILE, id])

export const createUnifiedUserProfile = (payload) => del([UNIFIED_USER_PROFILE], {}, payload)

export const uploadFile = (payload) =>
  post([DATA_EXPLORER, 'upload'], { removeTrailingSlash: true, formData: true }, payload)

export const getGeoStatistics = (payload) => post([DATA_EXPLORER, 'geo-statistics'], {}, payload)
export const getGeoCountryStatistics = (payload) =>
  post([DATA_EXPLORER, 'geo-country-statistics'], {}, payload)
export const getGeoStateStatistics = (payload) =>
  post([DATA_EXPLORER, 'geo-state-statistics'], {}, payload)
export const getGeoCountyStatistics = (payload) =>
  post([DATA_EXPLORER, 'geo-county-statistics'], {}, payload)
export const getGeoPostalCodeStatistics = (payload) =>
  post([DATA_EXPLORER, 'geo-zip-code-statistics'], {}, payload)

export const getScaleAndCoverage = (payload) =>
  post([DATA_EXPLORER, 'scale-and-coverage'], {}, payload)

export const getEventsByDate = (payload) => post([DATA_EXPLORER, 'events-by-date'], {}, payload)

export const getUsersByDate = (payload) => post([DATA_EXPLORER, 'users-by-date'], {}, payload)

export const getDataExport = (payload) =>
  post([DATA_EXPLORER, 'data-export'], { transformPayload: false }, payload)

export const getTopKeywords = (payload) =>
  post([DATA_EXPLORER, 'top-keywords'], { transformPayload: false }, payload)

export const getTopDomains = (payload) => post([DATA_EXPLORER, 'top-domains'], {}, payload)

export const getDistribution = (payload) => post([DATA_EXPLORER, 'distribution'], {}, payload)

export const getTrends = (payload) => post([DATA_EXPLORER, 'trends'], {}, payload)

export const getTermTrends = (payload) =>
  post([DATA_EXPLORER, 'term-trends'], { transformPayload: false }, payload)

export const getTrendingTerms = (payload, transformPayload = true) =>
  post(
    [DATA_EXPLORER, 'trending-terms'],
    {
      transformPayload,
    },
    payload
  )

export const getKeywordTrends = (payload) =>
  post([DATA_EXPLORER, 'keyword-trends'], { transformPayload: false }, payload)

export const getDomainTrends = (payload) =>
  post([DATA_EXPLORER, 'domain-trends'], { transformPayload: false }, payload)

export const getUniqueDomains = (payload) => post([DATA_EXPLORER, 'events-to-domains'], {}, payload)

export const snapshot = ({ id }) => post([EVENTS, 'snapshot', id], { removeTrailingSlash: true })

export const getMonitoring = (payload) => post([DATA_EXPLORER, 'delivery-stats'], {}, payload)

export const getTotalUsers = (payload) => post([DATA_EXPLORER, 'total-users'], {}, payload)

export const getCategoryUsers = (payload) => post([DATA_EXPLORER, 'category-users'], {}, payload)

export const getInterestScoreDistribution = (payload) =>
  post([DATA_EXPLORER, PREBUILT_ATTRIBUTES_V2, 'histogram'], {}, payload)

export const getPredictorsUserCounts = (payload) =>
  post([DATA_EXPLORER, PREBUILT_ATTRIBUTES_V2, 'user-counts'], {}, payload)

export const getPredictorsDataPreview = (payload) =>
  post([DATA_EXPLORER, PREBUILT_ATTRIBUTES_V2, 'data-preview'], {}, payload)

export const getDataMonitoringFilters = (payload) =>
  get([DATA_EXPLORER, 'monitoring', 'filters'], {}, payload)

export const getUrlSimilaritySeeds = (id) => get(['url-similarity-seeds', ...(id ? [id] : [])], {})

export const updateUrlSimilaritySeeds = (id, payload) =>
  put(['url-similarity-seeds', ...(id ? [id] : [])], {}, payload)

export const cloneUrlSimilaritySeeds = (payload) =>
  post(['url-similarity-seeds', 'clone', payload._id], { removeTrailingSlash: true }, payload)

export const deleteUrlSimilaritySeeds = (id) =>
  del(['url-similarity-seeds', ...(id ? [id] : [])], {})

export const getCustomTaxonomies = (id, params) =>
  get(['custom-taxonomies', ...(id ? [id] : [])], {}, params)

export const updateCustomTaxonomies = (id, payload) =>
  put(['custom-taxonomies', ...(id ? [id] : [])], {}, payload)

export const deleteCustomTaxonomies = (id) => del(['custom-taxonomies', ...(id ? [id] : [])], {})

export const getCategoryOverindex = (payload) =>
  post([DATA_EXPLORER, 'insights', 'category-overindex'], { transformPayload: false }, payload)
